<template>
  <section v-if="isGetRequestPending" class="edit-report">
    <p-loading />
  </section>
  <section v-else class="edit-report">
    <header>
      <h1>Edit Report</h1>
      <div class="action-wrapper">
        <p-button v-if="item && item.formId && $hasPermission('reports')" color="secondary" @click="confirmDelete">Delete</p-button>
      </div>
    </header>
    <p-edit-report :item="item" @submit="update" />
  </section>
</template>

<script>
import { mapState } from 'vuex';
import CreateOrEditReport from './_CreateOrEdit.vue';
import Loading from '@/components/common/Loading';
import Button from '@/components/common/Button';

export default {
  components: {
    'p-edit-report': CreateOrEditReport,
    'p-loading': Loading,
    'p-button': Button
  },
  computed: {
    ...mapState({
      item: (s) => s.reports.item,
      isGetRequestPending: (s) => s.reports.isGetRequestPending
    })
  },
  watch: {
    '$route.params': {
      handler() {
        this.$store.dispatch('reports/getById', this.$route.params.id);
      },
      immediate: true
    }
  },
  methods: {
    async update(data) {
      try {
        await this.$store.dispatch('reports/update', { ...data, id: this.$route.params.id });

        this.$toast.success({
          title: 'Update completed',
          message: `Report was updated.`
        });
        this.$router.push({ path: `/reports/` });
      } catch (e) {
        const { message } = JSON.parse(await e.response.text());
        this.$toast.error({
          title: 'Update failed',
          message: message || `Please, try again later or contact our development team.`
        });
      }
    },
    async confirmDelete() {
      if (!this.item?.formId) {
        return;
      }

      const { id, name } = this.item;

      const confirmResult = await this.$confirm({
        title: 'Delete report?',
        message: `Are you sure you want to delete report '${name}'?\n\nThis action can't be undone.`,
        confirm: 'Delete'
      });

      if (!confirmResult) {
        return;
      }

      const lock = this.$lock?.();
      try {
        await this.$store.dispatch('reports/delete', id);

        this.$toast.success({
          title: 'Report deleted',
          message: `Report '${name}' (${id}) was successfully deleted.`
        });
        this.$router.push({ path: `/reports` });
      } catch (e) {
        const { message } = JSON.parse(await e.response.text());
        this.$toast.error({
          title: 'Failed to delete report',
          message: message || `Please, try again later or contact our development team.`
        });
      } finally {
        lock?.release?.();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-report {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-rows: minmax(0, max-content) minmax(0, 1fr);
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 1rem;

  header {
    width: 100%;
    padding: 0.5rem 0.5rem 0 0;
    box-sizing: border-box;
    position: relative;
  }

  h1 {
    color: var(--theme-on-surface);
    font-size: 1.5rem;
    font-weight: 700;
  }

  .action-wrapper {
    position: absolute;
    right: 0rem;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
